<template>
  <div
    :class="
      twMerge(
        'bg-white border border-white-kft rounded-lg px-4 py-5',
        $attrs.class
      )
    "
  >
    <slot />
    <p v-if="contentText" class="text-slate-500 mt-2 text-sm">
      {{ contentText }}
    </p>
  </div>
</template>
<script setup>
import { twMerge } from 'tailwind-merge'

defineProps({
  contentText: { type: String, default: '' },
})
</script>
<style lang="css"></style>
